import React, {Component} from "react";
import SellerGigs from '../containers/SellerGigs';
import NewOrders from '../containers/NewOrders';
class SellerDashboard extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selected:'gigs'
        }
        
    }
   
    orders = (status) => {
        this.setState({selected:status})
    }

    render() {
        return( 
            <>
            <div className='row'>
                <div className='col col-lg-2 mt-5 pt-5'>
                    <div className="card mt-5 ms-5" style={{width: '15rem'}}>
                    <div className="card-header bg-primary" style={{textAlign:'center'}}>
                        <h2>Menu</h2>
                    </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item"><button className='btn' onClick={() => this.orders('gigs')} style={{width:'200px',textAlign:'left'}}>My Gigs</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.orders('new order')} style={{width:'200px',textAlign:'left'}}>New Orders</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.orders('confirmed')} style={{width:'200px',textAlign:'left'}}>Orders to be shipped</button></li>
                            <li className="list-group-item"><button className='btn' onClick={() => this.orders('shipped')} style={{width:'200px',textAlign:'left'}}>Completed Orders</button></li>
                        </ul>
                    </div>
                </div>
                <div className='col me-5'>
                {this.state.selected === 'gigs' ?
                    <SellerGigs/>
                    :
                this.state.selected==='new order' ?
                    <NewOrders status={'new order'}/>
                    :
                this.state.selected === 'confirmed' ?
                    <NewOrders status={'confirmed'} />
                    :
                    <NewOrders status={'shipped'} />
                }
                </div>
            </div>
            </>
        )
    }
}
export default SellerDashboard;